import React, { useState } from 'react'
import { Button, Select, makeStyles, MenuItem } from '@material-ui/core'
import SecurityRoleTreeView from '../components/SecurityRoleTreeView'

const useStyles = makeStyles(theme => ({
  roleSelectContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      marginBottom: '1rem'
    }
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'end',
    '& > *': {
      marginLeft: '1rem'
    }
  },
  treeViewContainer: {
    maxHeight: '50vh',
    overflow: 'auto',
    marginBottom: '2rem'
  },
  pushedLeft: {marginRight: 'auto', marginLeft: 0}
}))

const UserSecurityRole = (props) => {
  const { userName, userRole,user, securityRoles, onCancel, onSave } = props
  const classes = useStyles()

  const [newRole, setNewRole] = useState(user.userRole)
  const [showTreeView, setShowTreeView] = useState(false)
  const selectedRole = securityRoles.find((role) => role.roleID === newRole)
  return (
    <div>
      <div className={classes.roleSelectContainer}>
        Assign {userName} to a role
        <Select
          id='security-select'
          variant='outlined'
          value={newRole}
          onChange={(ev) => {
            setNewRole(ev.target.value)
          }}
        >
          {securityRoles.map((role, i) => {
            return (
              <MenuItem key={'role' + i} value={role.roleID}>
                {role.roleName}
              </MenuItem>
            )
          })}
        </Select>
        <span>{selectedRole && selectedRole.roleDescription || `Unknown user role(${user.userRole})`}</span>
      </div>
      {showTreeView ? <div className={classes.treeViewContainer}>
        <SecurityRoleTreeView role={securityRoles.find(role => role.roleID === newRole)} />
      </div> : null}
      <div className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          className={classes.pushedLeft}
          onClick={() => setShowTreeView(!showTreeView)}
        >
          {showTreeView ? 'Hide ' : 'Show '}Role Permissions
        </Button>
        <Button
          variant='contained'
          color='secondary'
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => onSave(newRole)}
          disabled={newRole === user.userRole}
        >
          Update
        </Button>
      </div>
    </div>
  )
}

export default UserSecurityRole
